export default "__VITE_ASSET__D2HK_ti2__"